"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventProperties = exports.buildSearchParams = exports.generateSlug = exports.extractEventProperties = exports.getPageType = exports.matchPageTypeWithPattern = void 0;
var constants_1 = require("../constants");
var pageTypePatterns = new Map([
    [/\bcard\b|card/i, constants_1.PageType.Card],
    [/(favorite|favourites)|\b(favorite|favourites)/i, constants_1.PageType.Favorites],
    [/auth\//i, constants_1.PageType.Account],
    [/productdetails\//i, constants_1.PageType.Pdp],
]);
var matchPageTypeWithPattern = function (payload, screenName) {
    var pageMatch = Array.from(pageTypePatterns.entries()).find(function (_a) {
        var _b;
        var pattern = _a[0];
        return pattern.test(((_b = payload === null || payload === void 0 ? void 0 : payload.path) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
            (payload === null || payload === void 0 ? void 0 : payload.feature) ||
            screenName.toLowerCase());
    });
    if (pageMatch) {
        return pageMatch === null || pageMatch === void 0 ? void 0 : pageMatch[1];
    }
};
exports.matchPageTypeWithPattern = matchPageTypeWithPattern;
var getPageType = function (payload) {
    var _a, _b, _c, _d, _e, _f, _g;
    var screenName = (_b = (_a = payload.currentRoute) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    var currentRoute = payload.currentRoute;
    var currentRouteParams = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.params;
    var trackingParams = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.trackingParams;
    var isCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_c = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _c === void 0 ? void 0 : _c.split('/').length) === 1
        : false;
    var isSubCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_d = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _d === void 0 ? void 0 : _d.split('/').length) > 1
        : false;
    if (((_e = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.trackingParams) === null || _e === void 0 ? void 0 : _e.page_type) || (trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.page_type)) {
        return ((_f = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.trackingParams) === null || _f === void 0 ? void 0 : _f.page_type) || (trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.page_type);
    }
    var extractPageTypeFromWebViewPath = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) &&
        constants_1.pageTypes.find(function (item) { var _a, _b; return item.includes((_b = (_a = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) === null || _a === void 0 ? void 0 : _a.replace('/', '')) !== null && _b !== void 0 ? _b : ''); });
    var matchPageType = (0, exports.matchPageTypeWithPattern)({
        path: payload.path,
        feature: payload.feature,
    }, screenName);
    var pageTypeProperties = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (matchPageType && {
        page_type: matchPageType,
    })), (extractPageTypeFromWebViewPath && {
        page_type: extractPageTypeFromWebViewPath,
    })), ((currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug) && {
        page_type: constants_1.PageType.Pdp,
    })), ((trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.term) && {
        page_type: constants_1.PageType.Search,
    })), (isCategory && {
        page_type: constants_1.PageType.Category,
    })), (isSubCategory && {
        page_type: constants_1.PageType.SubCategory,
    })), ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.page_type) && {
        page_type: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.page_type,
    }));
    var pageType = constants_1.pageTypes.find(function (type) { return type === screenName.toLowerCase(); });
    return (_g = pageTypeProperties === null || pageTypeProperties === void 0 ? void 0 : pageTypeProperties.page_type) !== null && _g !== void 0 ? _g : pageType;
};
exports.getPageType = getPageType;
var extractEventProperties = function (currentRoute, store, locale, path) {
    var _a, _b;
    var currentRouteParams = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.params;
    var isCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_a = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _a === void 0 ? void 0 : _a.split('/').length) === 1
        : false;
    var isSubCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_b = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _b === void 0 ? void 0 : _b.split('/').length) > 1
        : false;
    var extractPageTypeFromWebViewPath = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) &&
        constants_1.pageTypes.find(function (item) { var _a, _b; return item.includes((_b = (_a = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) === null || _a === void 0 ? void 0 : _a.replace('/', '')) !== null && _b !== void 0 ? _b : ''); });
    var trackingParams = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.trackingParams;
    var pageType = (0, exports.getPageType)({
        currentRoute: currentRoute,
        path: path,
        feature: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.feature,
    });
    var properties = __assign(__assign(__assign(__assign(__assign({ store: store, locale: locale, page_type: pageType }, ((currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug) && {
        slug: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug,
        product_sku: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.sku,
    })), ((trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.term) && {
        term: trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.term,
    })), (isCategory && {
        category_name: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.title,
    })), (isSubCategory && {
        subcategory_name: trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.subCategoryTitle,
    })), (extractPageTypeFromWebViewPath && {
        slug: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug,
    }));
    return properties;
};
exports.extractEventProperties = extractEventProperties;
var generateSlug = function (screenViewProperties, path, fallbackSlug) {
    var _a;
    var _b;
    var page_type = (0, exports.getPageType)({ path: path });
    var customSlugProperties = (_a = {},
        _a[constants_1.PageType.Home] = 'home',
        _a[constants_1.PageType.Deals] = 'deals',
        _a[constants_1.PageType.HowItWorks] = 'how-it-works',
        _a[constants_1.PageType.Category] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.category_name) || '',
        _a[constants_1.PageType.SubCategory] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.subcategory_name) || '',
        _a[constants_1.PageType.Pdp] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.slug) || '',
        _a[constants_1.PageType.Search] = 'search',
        _a[constants_1.PageType.Card] = path,
        _a['favorite'] = 'favorites',
        _a);
    var pageType = page_type || (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.page_type) || '';
    var slugFromPageType = pageType
        ? customSlugProperties[pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()]
        : customSlugProperties[(_b = fallbackSlug === null || fallbackSlug === void 0 ? void 0 : fallbackSlug.toLowerCase()) !== null && _b !== void 0 ? _b : ''];
    var customSlugValue = slugFromPageType !== null && slugFromPageType !== void 0 ? slugFromPageType : customSlugProperties[pageType];
    if (customSlugValue) {
        return customSlugValue.toLowerCase();
    }
    if (!customSlugValue) {
        return constants_1.pageTypes.includes(pageType)
            ? pageType.toLowerCase()
            : (fallbackSlug || '').toLocaleLowerCase();
    }
};
exports.generateSlug = generateSlug;
var buildSearchParams = function (term) {
    var encodedTerm = encodeURIComponent(term);
    var searchParams = new URLSearchParams({ terms: encodedTerm });
    return "?".concat(searchParams.toString());
};
exports.buildSearchParams = buildSearchParams;
var getEventProperties = function (currentRoute, storeCode, localeValue, extraProperties) {
    var _a;
    var path = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.path;
    var eventProperties = (0, exports.extractEventProperties)(currentRoute, storeCode, localeValue, String(path));
    var slug = (0, exports.generateSlug)(eventProperties, path, currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.name);
    var term = (_a = eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.term) !== null && _a !== void 0 ? _a : '';
    var search = (0, exports.buildSearchParams)(term);
    var store = eventProperties.store, locale = eventProperties.locale, category_name = eventProperties.category_name, subcategory_name = eventProperties.subcategory_name, page_type = eventProperties.page_type;
    var result = __assign(__assign({ store: store, locale: locale, slug: slug, page_type: page_type, category_name: category_name }, extraProperties), { subcategory_name: subcategory_name });
    if (term) {
        result.search = search;
    }
    var filteredResult = Object.fromEntries(Object.entries(result).filter(function (_a) {
        var value = _a[1];
        return value !== undefined;
    }));
    return filteredResult;
};
exports.getEventProperties = getEventProperties;
//# sourceMappingURL=eventUtils.js.map